import React from 'react';
import PropTypes from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './CardSection.scss';

const TYPES = ['header', 'default'];

/**
 * @deprecated
 */
export default class CardSection extends BaseComponent {
  render() {
    const { children, className, id, style, type } = this.props;

    const classNames = ClassNames(['card-section', className, type]);

    return (
      <div id={id} style={style} className={classNames}>
        {children}
      </div>
    );
  }
}

CardSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  id: PropTypes.string,
  style: PropTypes.shape({}),
  type: PropTypes.oneOf(TYPES)
};

CardSection.defaultProps = {
  className: undefined,
  children: undefined,
  id: undefined,
  style: {},
  type: undefined
};
